import { TableCell as MuiTableCell, } from '@mui/material';
import { font } from '../../styles';
import { styled } from '../../utils';
export const TableCell = styled(MuiTableCell, {
    shouldForwardProp: (prop) => prop !== 'striped' &&
        prop !== 'cellPadding' &&
        prop !== 'cellSize' &&
        prop !== 'style',
})(({ theme, cellPadding, striped, style, cellSize }) => ({
    ...theme.typography.body1,
    border: 0,
    color: theme.palette.primary.dark,
    padding: cellPadding === 'small' ? theme.spacing(1.5, 1.5) : theme.spacing(2.5, 1.5),
    background: striped ? theme.palette.groupPrimary.lighterDove : 'white',
    '&.MuiTableCell-root': {
        padding: theme.spacing(1, 1),
        fontSize: cellSize === 'small' && font.size.s,
        '&.MuiTableCell-head': {
            padding: theme.spacing(1, 1),
        },
    },
    ...style,
}));
